import { AppEvents, EventBus } from '../shared/eventBus';
import { RoomEntryScreen } from './screens/RoomEntryScreen';
import { ConnectingScreen } from './screens/ConnectingScreen';
import { ControllerWaitingScreen } from './screens/ControllerWaitingScreen';
import { MenuScreen } from './screens/MenuScreen';
import { GameScreen } from './screens/GameScreen';

type Transition = {
  from : number,
  to : number
}
const STATES = {
  ROOM_ENTRY:0,
  CONNECTING:1,
  WAITING_ROOM:2,
  MENU:3,
  GAME:4
}

const TRANSITIONS = {
  CONNECT:{ from:STATES.ROOM_ENTRY, to:STATES.CONNECTING },
  CONNECTED:{ from:STATES.CONNECTING, to:STATES.WAITING_ROOM},
  ROOM_READY:{ from:STATES.WAITING_ROOM, to:STATES.MENU },
  LOAD_GAME:{ from:STATES.MENU, to:STATES.GAME }
}

export class UiManager {
  private container: HTMLElement;
  private screens: Map<number, any> = new Map();
  private eventBus: EventBus<AppEvents>;
  private state:number;

  constructor(eventBus:EventBus<AppEvents> ,containerId: string = 'app') {
    this.state = STATES.CONNECTING;
    const container = document.getElementById(containerId);
    if (!container) {
      throw new Error(`Container element with id '${containerId}' not found`);
    }
    this.container = container;
    this.eventBus = eventBus;
    this.initializeScreens();
    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    this.eventBus.subscribe("connected",()=>{
      // this.applyTransition(TRANSITIONS.CONNECTED);
    });
    this.eventBus.subscribe("role_recieved",(role)=>{
      const controllerWaitingScreen = this.screens.get(STATES.WAITING_ROOM);
      controllerWaitingScreen.setRole(role);
      this.applyTransition(TRANSITIONS.CONNECTED);
    });

    // this.eventBus.subscribe("game_loaded",(data:any)=>{
    //   const gameScreen = this.screens.get(STATES.GAME) as any;
    //   gameScreen?.loadIframe(data.url);
    //   this.applyTransition(TRANSITIONS.LOAD_GAME);
    // });

    this.eventBus.subscribe("game_loaded",(url)=>{
      // const gameScreen = this.screens.get(STATES.GAME) as any;
      // gameScreen?.loadIframe(url);
      this.applyTransition(TRANSITIONS.LOAD_GAME);
    })

  }

  private initializeScreens(): void {
    // this.screens.set(STATES.ROOM_ENTRY,new RoomEntryScreen());
    this.screens.set(STATES.CONNECTING, new ConnectingScreen());
    this.screens.set(STATES.WAITING_ROOM, new ControllerWaitingScreen());
    this.screens.set(STATES.MENU, new MenuScreen());
    this.screens.set(STATES.GAME, new GameScreen());

    this.updateUI(STATES.CONNECTING);
    // this.applyTransition(TRANSITIONS.CONNECT);

    this.subscribeScreenEvents();
  }

  private applyTransition(transition:Transition){
    if(transition.from != this.state){
      throw new Error("invalid transition called");
    }
    this.state = transition.to;
    this.updateUI(transition.from)
  }

  private subscribeScreenEvents(){
    const roomEntryScreen = this.screens.get(STATES.ROOM_ENTRY);
    roomEntryScreen?.on("join_room_clicked",(data)=>{
      this.eventBus.publish("join_room_clicked",data);
      this.applyTransition(TRANSITIONS.CONNECT);
    });

    const controllerWaitingScreen = this.screens.get(STATES.WAITING_ROOM);
    controllerWaitingScreen?.on("room_ready",()=>{
      this.eventBus.publish("room_ready",()=>{});
      this.applyTransition(TRANSITIONS.ROOM_READY);
    })

    const menuScreen = this.screens.get(STATES.MENU);
    menuScreen?.on("buttonPress",(data)=>{
      this.eventBus.publish("menu:button_press",data);
    })

    const gameScreen = this.screens.get(STATES.GAME);
    gameScreen?.on("accelerate_on",()=>{
      this.eventBus.publish("game:accelerate_on",null);
    });
    gameScreen?.on("accelerate_off",()=>{
      this.eventBus.publish("game:accelerate_off",null);
    });
    gameScreen?.on("brake_on",()=>{
      this.eventBus.publish("game:brake_on",null);
    });
    gameScreen?.on("brake_off",()=>{
      this.eventBus.publish("game:brake_off",null);
    });
  }

  private updateUI(from:number){
    const previousScreen = this.screens.get(from);
    previousScreen.removeEventListeners();
    const newScreen = this.screens.get(this.state);
    this.container.innerHTML = newScreen.getElement();
    newScreen.addEventListeners();
  }

  public destroy(): void {

  }
}